import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons/faCheckCircle';

import React from 'react';

import style from './label-provider-logo.module.less';

export const VoidedMasLabelProviderLogo = () => {
  return (
    <div className={style['voided-mas-label-provider-logo']}>
      <FontAwesomeIcon icon={faCheckCircle} />
    </div>
  );
};
